import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import BootstrapVue from 'bootstrap-vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import './assets/scss/custom.scss';
import VueMonthlyPicker from 'vue-monthly-picker'
import Spinner from 'vue-spinkit';
import utils from './utils';
import VueNativeSock from "vue-native-websocket";
import VueSidebarMenu from 'vue-sidebar-menu';
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css';
import VueCookies from 'vue-cookies';
import moment from 'moment';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/fr';

moment.locale('fr');
Vue.use(VueSidebarMenu);
Vue.use(VueCookies);


Vue.use(VueNativeSock, process.env.VUE_APP_WEBSOCKET_URL, {
  protocol: "echo-protocol",
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 3000,
});



Vue.config.productionTip = false
library.add(fas);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('Spinner', Spinner)
Vue.use(BootstrapVue);
Vue.component('pagination', require('laravel-vue-pagination'));
Vue.component('my-component', {
  components: {
      VueMonthlyPicker
  }
});

router.afterEach((to, from) => {
  utils.displayMenu();
});


new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
